import React from 'react';

export default class OrderUnfinished extends React.PureComponent {
  render() {
    return (
      <div>
        <p>{kroostApp.strings.orderUnfinishedFirstPart}</p>
        <p>{kroostApp.strings.orderUnfinishedSecondPart}</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/order-unfinished/index.js